import React, { createContext, useContext } from "react";
import { Mode } from ".";

export type LeftNavContextType = {
  mode: Mode;
  currentLevel: number;
  setLevel: (level: number) => void;
};

const LeftNavContext = createContext<LeftNavContextType | undefined>(undefined);

export function LeftNavProvider({
  children,
  mode = "full",
  currentLevel = 0,
  setLevel = () => {},
}: {
  children: React.ReactNode;
  mode?: Mode;
  currentLevel?: number;
  setLevel?: (level: number) => void;
}) {
  return (
    <LeftNavContext.Provider value={{ mode, currentLevel, setLevel }}>
      {children}
    </LeftNavContext.Provider>
  );
}

export function useLeftNav() {
  const context = useContext(LeftNavContext);
  if (context === undefined) {
    throw new Error("useLeftNav must be used within a LeftNavProvider");
  }
  return {
    mode: context.mode,
    currentLevel: context.currentLevel,
    setLevel: context.setLevel,
  };
}
